<template>
  <div
    v-if="!isEmptyData(items) && hasValidColumns"
    class="pre-alert-table orders"
    ref="preAlertTable"
  >
    <v-table
      ref="pre_alert"
      name="pre-alert"
      :items="items"
      :rowClass="rowClass"
      :cellClass="cellClass"
      :hover="false"
      :scrollingSpeed="0.5"
      :coreColumnDefs="columnDefs"
      :columnOptions="{ selector }"
      :columnEvent="columnEvent"
      :rowHeight="50"
      :getHeight="getHeight"
    />
  </div>
</template>
<script>
import api from "@/default/utils/api";
import "@/default/pages/containers/pre_alert/cells/index.js";
import "@/default/pages/containers/shared/shared.js";
export default {
  name: "ContainerPreAlertTable",
  mixins: [api],
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    offset: {
      type: Number,
      required: false,
    },
    selector: {
      type: Boolean,
      default: true,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.initCachedColumns();
  },
  data() {
    return {
      coreColumnDefs: [
        {
          name: "ID",
          field: "id",
          key: "id",
          width: 70,
          minWidth: 70,
          fixed: "left",
          classes: "cell-style",
          component: "pre-alert-id",
        },
        {
          name: "Action",
          key: "action",
          width: 75,
          minWidth: 75,
          fixed: "left",
          classes: "cell-style",
          sortable: false,
          component: "pre-alert-action",
        },
        {
          name: "Type",
          field: "abbrev_type",
          key: "type",
          width: 65,
          component: "v-table-column",
        },
        {
          name: "Customer",
          field: "customer.name",
          key: "customer",
          width: 125,
          component: "pre-alert-customer",
        },
        {
          name: "Chassis#",
          field: "chassis_no",
          key: "chassis_no",
          width: 100,
          component: "pre-alert-chassis-no",
        },
        {
          name: "Pickup#",
          field: "pickup_no",
          key: "pickup_no",
          width: 100,
          only: ["import", "xtown"],
          component: "pre-alert-pickup-no",
        },
        {
          name: "Ssline",
          field: "ssline.name",
          key: "ssline",
          width: 115,
          component: "pre-alert-ssline",
        },
        {
          name: "Terminals",
          field: "terminals[0].name",
          key: "terminals",
          width: 120,
          component: "pre-alert-terminals",
        },
        {
          name: "Latest Event",
          field: "traces.terminal.move_event.status",
          key: "lastest_event",
          width: 150,
          only: ["import", "xtown"],
          component: "v-table-column",
        },
        {
          name: "Event Location",
          field: "traces.terminal.move_event.location.city",
          key: "event_location",
          width: 150,
          only: ["import", "xtown"],
          component: "pre-alert-current-location",
        },
        {
          name: "Event Date/Time",
          field: "traces.terminal.move_event.date_time",
          key: "event_date_time",
          width: 140,
          only: ["import", "xtown"],
          component: "v-table-column",
        },

        {
          name: "Customs Rlsd.",
          field: "customs_released_date",
          path: "customs_release_status",
          key: "customs_release",
          width: 120,
          only: ["import"],
          type: "customs",
          component: "pre-alert-release",
        },
        {
          name: "Line Rlsd.",
          field: "line_released_date",
          path: "line_release_status",
          key: "line_release",
          width: 100,
          only: ["import"],
          type: "line",
          component: "pre-alert-release",
        },
        {
          name: "Disch. Date",
          field: "discharged_date",
          key: "discharged_date",
          width: 105,
          only: ["import"],
          component: "pre-alert-release",
        },
        {
          name: "Line LFD",
          field: "line_lfd",
          key: "line_lfd",
          width: 90,
          only: ["import"],
          component: "pre-alert-release",
        },
        {
          name: "Term. ETA",
          field: "eta",
          key: "eta",
          width: 105,
          minWidth: 105,
          only: ["import", "xtown"],
          component: "pre-alert-eta",
        },
        {
          name: "ERD",
          field: "erd",
          key: "erd",
          width: 115,
          aliasName: "Early Receiving Date",
          only: ["export"],
          component: "pre-alert-erd",
        },
        {
          name: "Appt. Time",
          field: "appointment",
          key: "appt",
          width: 135,
          minWidth: 135,
          component: "appt-time",
        },
        {
          name: "Term. LFD",
          field: "lfd",
          key: "lfd",
          width: 105,
          minWidth: 105,
          aliasName: "Last Free Day",
          only: ["import", "xtown"],
          classes: "cell-style tight",
          component: "pre-alert-lfd",
        },
        {
          name: "COD",
          field: "cod",
          key: "cod",
          width: 115,
          aliasName: "Cut Off Date",
          only: ["export"],
          component: "pre-alert-cod",
        },
        {
          name: "Confirmed By",
          field: "public_comment",
          key: "confirmed_by",
          width: 115,
          component: "pre-alert-confirmed-by",
        },
        {
          name: "Hold",
          field: "appt_hold",
          key: "hold",
          aliasName: "Appt. Hold",
          width: 65,
          component: "pre-alert-hold",
        },
        {
          name: "PRI",
          field: "priority.value",
          key: "pri",
          width: 55,
          classes: "cell-style",
          aliasName: "Priority",
          component: "pre-alert-priority",
        },
        {
          name: "CONT.#",
          field: "container_no",
          key: "container_no",
          width: 115,
          classes: "cell-style",
          component: "pre-alert-cont-no",
        },
        {
          name: "Size/Type",
          field: "ctype",
          key: "ctype",
          width: 80,
          component: "pre-alert-ctype",
        },
        {
          name: "TRI",
          field: "triaxle",
          key: "triaxle",
          width: 55,
          classes: "cell-style",
          aliasName: "Triaxle",
          component: "pre-alert-triaxle",
        },
        {
          name: "HAZ",
          field: "haz_cargo",
          key: "haz",
          width: 55,
          classes: "cell-style",
          component: "pre-alert-haz",
        },
        {
          name: "SSLine B/L#",
          field: "bl_no",
          key: "bl_no",
          width: 120,
          component: "pre-alert-ssline-bl-no",
        },
        {
          name: "Warehouse",
          field: "warehouses[0].name",
          key: "warehouse",
          width: 180,
          aliasName: "Warehouse Name",
          only: ["import", "export"],
          component: "pre-alert-warehouse-name",
        },
        {
          name: "City",
          field: "warehouses[0].city",
          key: "warehouse_city",
          width: 75,
          aliasName: "Warehouse City",
          only: ["import", "export"],
          component: "pre-alert-warehouse-city",
        },
        {
          name: "State",
          field: "warehouses[0].state",
          key: "warehouse_state",
          width: 55,
          aliasName: "Warehouse State",
          only: ["import", "export"],
          component: "pre-alert-warehouse-state",
        },
        {
          name: "Location",
          field: "pickup_detail.location",
          key: "pickup_location",
          width: 150,
          aliasName: "Pickup Location",
          classes: "cell-style tight",
          component: "pre-alert-pickup-location",
        },
        {
          name: "Instruction",
          field: "pickup_detail.instructions",
          key: "pickup_instruction",
          width: 150,
          aliasName: "Pickup Instruction",
          classes: "cell-style tight",
          component: "pre-alert-pickup-instruction",
        },
      ],
    };
  },
  watch: {
    offset(nv, ov) {
      if (nv != ov) {
        window.dispatchEvent(new Event("resize"));
      }
    },
  },
  computed: {
    hasValidColumns() {
      return this.columnDefs.length > 0;
    },
    columnDefs() {
      return this.coreColumnDefs.filter(
        (o) => o.only == null || o.only.includes(this.type.toLowerCase()),
      );
    },
    bufferScale() {
      return Math.max(1, Math.round(this.items.length / 100));
    },
  },
  methods: {
    initCachedColumns() {
      let columns = [
        "ID",
        "Action",
        "Type",
        "Customer",
        "Chassis#",
        "Pickup#",
        "Ssline",
        "Terminals",
        "Latest Event",
        "Event Location",
        "Event Date/Time",
        "Customs Rlsd.",
        "Line Rlsd.",
        "Disch. Date",
        "Line LFD",
        "Term. ETA",
        "Early Receiving Date",
        "Appt. Time",
        "Appt. Hold",
        "Priority",
        "Last Free Day",
        "Cut Off Date",
        "Confirmed By",
        "CONT.#",
        "Size/Type",
        "Triaxle",
        "HAZ",
        "SSLine B/L#",
        "Warehouse Name",
        "Warehouse City",
        "Warehouse State",
        "Pickup Location",
        "Pickup Instruction",
      ];
      if (!this.$store.envs.trace) {
        ["Latest Event", "Event Location", "Event Date/Time"].forEach(
          (name) => {
            columns.splice(columns.indexOf(name), 1);
            let index = this.coreColumnDefs.findIndex((o) => o.title == name);
            this.coreColumnDefs.splice(index, 1);
          },
        );
      }

      this.$actions.renameTableColumn("pre-alert", "ETA", "Term. ETA");
      this.initTableColumns("pre-alert", columns);
      this.$emit("initColumnOptions");
    },
    columnEvent(fn, ...args) {
      this[fn](...args);
    },
    autoSave(item, column, value) {
      let params = { type: item.type, column, value };
      this.$http
        .put(`/api/v1/attrs/${item.id}`, params)
        .then((response) => {
          this.$message({
            message: "It was changed successfully",
            type: "success",
          });
          if (column == "terminal_eta") {
            this.$emit("loadChartData");
          }
          if (column == "weight") {
            this.checkTriaxle(item);
          }
        })
        .catch((err) => {
          this.$message({ message: err.response.data.errors, type: "error" });
        });
    },
    rowClass({ row }) {
      let rowColor = `row-${row.color}`;
      return { hp: row.priority.name == "high", [rowColor]: true };
    },
    cellClass({ row, column, rowIndex, columnIndex }) {
      if (column.label == "CONT.#") return `cell-${row.type_color}`;
      const portOnly = [
        "customs_released_date",
        "line_released_date",
        "discharged_date",
        "line_lfd",
      ];
      const railOnly = ["eta", "pickup_no"];
      const rail = row.drayage_mode == "rail";
      const unused =
        (rail && portOnly.includes(column.property)) ||
        (!rail && railOnly.includes(column.property));
      if (unused) return "cell-style cell-unused";
    },
    getHeight() {
      return this.autoHeight ? "auto" : window.innerHeight - this.offset;
    },
    checkTriaxle(item) {
      this.$http
        .post("/api/v1/containers/is_triaxle", {
          container: { ctype: item.ctype, weight: item.weight },
        })
        .then((response) => {
          if (response.data.triaxle && !item.triaxle) {
            this.$confirm(
              "Do you want to apply triaxle to this move?",
              "Triaxle Weight",
              {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning",
              },
            )
              .then(() => {
                this.autoSave(item, "triaxle", true);
              })
              .catch(() => {});
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="scss">
.pre-alert-table {
  div.lfda {
    @apply p-1 bg-pink-300;
  }

  div.lfdaa {
    @apply p-0.5 bg-red-500;
  }
}
</style>
